import { render, staticRenderFns } from "./homepageTeaser.vue?vue&type=template&id=10e75048&"
import script from "./homepageTeaser.vue?vue&type=script&lang=js&"
export * from "./homepageTeaser.vue?vue&type=script&lang=js&"
import style0 from "./homepageTeaser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports